import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=9437f71a&scoped=true&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9437f71a",
  null
  
)

export default component.exports